__turbopack_context__.v({
  "closedBadge": "DonateAndShareSection-module__3AiZ0a__closedBadge",
  "container": "DonateAndShareSection-module__3AiZ0a__container",
});
